import { LinkedAccountDto } from '../interfaces/linked-account-result';

export class Package{
    packageId: string;
    createdOn: Date;
    shippedOn: Date;
    requestType: any[];
    accountCodes: LinkedAccountDto[];
    recievingLab: string;
    shipperType: string;
    status: string;
    trackingId: string;
}

export class CancelPackageDto {
    labportPackageCode: string;
    requistionIds: string[];
    accountCode: string;
}


export class CancelOrderDto {
    requisitionNumber: string;
    accountCode: string;
}

export class SendPackageDto {
    packageId: string;
    trackingId: string;
    shipperType: string;
}

export class PackageSearchRequestDto {
  packageOrRequisition: string[];
  accountCodes: string[];
}
export class PackageSearchResponseDto {
  packageId: string;
  labPortPackageCode: string;
  requsitionNumber: string;
  packageIsDeleted: string;
  requisitionIsDeleted: string;
}

export class CanPlaceUserPrePrintedOrderRequest {
  pacakageAccountId : string;
  orderAccountId : string;
  requestType : string;
}

export class PrePrintedLabelDialogData {
  packageAccountCode : string;
  packageAccountName : string;
  usePrePrintedLabels: boolean;
  requistion : string;
}
